import React from 'react';

import styled, { css } from 'styled-components';

import { URL_IMAGES_PAYSYSTEMS } from 'constants/UrlConstants';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const PartnersList = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    ${promoMedia.tablet744} {
        max-width: 482px;
    }

    ${promoMedia.desktop1440} {
        max-width: 962px;
    }
`;
const CommonCss = css`
    display: inline-block;
    height: 64px;
    width: 64px;
    margin-bottom: 12px;
    margin-right: 28px;

    ${promoMedia.tablet744} {
        margin-right: 32px;
    }

    img {
        width: 100%;
    }
`;

const PartnersLink = styled.a`
    ${CommonCss}

    &:focus-visible {
        background-color: ${promoColors.gray20};
        outline: 1px dashed ${promoColors.gray80};
    }
`;
const PartnersSpan = styled.span`
    ${CommonCss}
`;

export default function Partners() {
    return (
        <PartnersList>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/mastercard-squared.svg`} loading="lazy" decoding="async" alt="Mastercard" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/visa-squared.svg`} loading="lazy" decoding="async" alt="Visa" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/unionpay-squared.svg`} loading="lazy" decoding="async" alt="Unionpay" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/visa-verified-squared.svg`} loading="lazy" decoding="async" alt="Verified by Visa" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img
                    src={`${URL_IMAGES_PAYSYSTEMS}/mastercard-secure-squared.svg`}
                    loading="lazy"
                    decoding="async"
                    alt="Mastercard secure code"
                    width="64"
                    height="64"
                />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/napas-squared.svg`} loading="lazy" decoding="async" alt="Napas" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/humo-squared.svg`} loading="lazy" decoding="async" alt="Humo" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/troy-squared.svg`} loading="lazy" decoding="async" alt="Troy" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/uzcard-squared.svg`} loading="lazy" decoding="async" alt="Uzcard" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/verve-squared.svg`} loading="lazy" decoding="async" alt="Verve" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/elcard-squared.svg`} loading="lazy" decoding="async" alt="Elcard" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/kortimilli-squared.svg`} loading="lazy" decoding="async" alt="Kortimilli" width="64" height="64" />
            </PartnersSpan>
            <PartnersSpan>
                <img src={`${URL_IMAGES_PAYSYSTEMS}/sepa-squared.svg`} loading="lazy" decoding="async" alt="Sepa" width="64" height="64" />
            </PartnersSpan>
            <PartnersLink href="https://cloud.paysend.com/web/docs/certificate_pci_dss_en.pdf" target="_blank">
                <img src={`${URL_IMAGES_PAYSYSTEMS}/pci-dss-squared.svg`} loading="lazy" decoding="async" alt="PCI" width="64" height="64" />
            </PartnersLink>
        </PartnersList>
    );
}
